import getEpisodeEditFormSchema from '@app/organisms/EpisodeEditForm/schemas/episodeEditFormSchema';

const getPublishSchema = (intl) => {
    const baseSchema = getEpisodeEditFormSchema(intl);

    return baseSchema.clone();
};

export default getPublishSchema;
